module.exports = __webpack_public_path__ + "img/goDown.26930ddc.svg";